export default __webpack_public_path__ + "static/media/slide6.82538beb.png";